'use es6';

import PropTypes from 'prop-types';
import RequestStatusTypes from '../RequestStatusTypes';
export var requestStatusPropType = PropTypes.oneOf(Object.values(RequestStatusTypes));